var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHostLandingBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 797,
    height: 470.742,
    viewBox: "0 0 797 470.742",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_587",
    "data-name": "Group 587",
    transform: "translate(-33 -216.598)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_85",
    "data-name": "Ellipse 85",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(818 216.598)",
    fill: "#00c3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M19,0A19,19,0,1,1,0,19,19,19,0,0,1,19,0Z",
    transform: "translate(33 489)",
    fill: "#00c3ff",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_3",
    "data-name": "Polygon 3",
    transform: "translate(777.537 660) rotate(43)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.392,0,20.785,18H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10.39230442047119 2.000008583068848 L 1.732059478759766 17 L 19.05254936218262 17 L 10.39230442047119 2.000008583068848 M 10.39230442047119 0 L 20.78460502624512 18 L 3.814697265625e-06 18 L 10.39230442047119 0 Z",
    stroke: "none",
    fill: "#00c3ff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostLandingBackground);
export default __webpack_public_path__ + "static/media/HostLandingBackground.4ce498bd7385572c6f1aafec4202c838.svg";
export { ForwardRef as ReactComponent };